/* Renders the speedo needle */
import React from "react"
import { useSpring, animated } from "react-spring"

import SpeedNeedle from "../svgs/speedNeedle"

interface NeedleProps {
  angle: number
}

// Old transition code before react-spring
//     css`
//       transition-property: transform;
//       transition-duration: 300ms;
//       transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
//       transform-origin: 50% 81%;
//       transform: rotate(${angle}deg);
//     `,

const Needle: React.FC<NeedleProps> = ({ angle }) => {
  const props = useSpring({
    to: { transform: `rotate(${angle}deg)` },
    config: {
      mass: 1,
      tension: 400,
      friction: 17,
    },
  })
  return (
    <animated.div style={{ ...props, transformOrigin: "50% 81.5%" }}>
      <SpeedNeedle />
    </animated.div>
  )
}

export default Needle
